module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('img', {
    attrs: {
      "src": require("@/img/logo_main.png"),
      "alt": "Les mystères de pékin"
    },
    on: {
      "click": _vm.goPlay
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "home-btn btn",
    attrs: {
      "to": "choisir-son-personnage"
    }
  }, [_vm._v("Jouer")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7958d817"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 88
// module chunks = 0